{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Templates",
    "DESCRIPTION": "Bekijk de berichttemplates die zijn gesynchroniseerd vanuit uw WhatsApp-inboxen. Om een template te maken of te bewerken, beheert u deze bij uw provider.",
    "COUNT": "{n} template | {n} templates",
    "LEARN_MORE": "Meer informatie over WhatsApp-templates",
    "SYNC_TEMPLATES": "Templates synchroniseren",
    "SYNC_SUCCESS": "Synchronisatie van templates gestart voor alle WhatsApp-inboxen. Wijzigingen kunnen enkele minuten duren.",
    "PARTIAL_SYNC_ERROR": "Synchronisatie van templates gestart voor sommige WhatsApp-inboxen, maar andere konden niet worden gesynchroniseerd.",
    "SYNC_ERROR": "Kan de synchronisatie van templates niet starten. Probeer het opnieuw.",
    "SEARCH_PLACEHOLDER": "Zoeken op inhoud of naam...",
    "MANAGE_IN_META": "Beheren in Meta",
    "LOADING": "WhatsApp-templates laden...",
    "EMPTY": "Geen WhatsApp-templates gevonden.",
    "NO_RESULTS": "Geen templates komen overeen met uw filters.",
    "FETCH_ERROR": "Kan WhatsApp-templates niet laden. Probeer het opnieuw.",
    "PARTIAL_FETCH_ERROR": "Sommige WhatsApp-templates konden niet worden geladen. Probeer het opnieuw.",
    "LAST_SYNC_ATTEMPT": "Laatste synchronisatiepoging op {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Niet ingediend voor WhatsApp-goedkeuring"
    },
    "FILTERS": {
      "ALL_INBOXES": "Alle inboxen",
      "ALL_LANGUAGES": "Alle talen",
      "ALL_TYPES": "Alle typen"
    },
    "TYPES": {
      "TEXT": "Tekst",
      "IMAGE": "Afbeelding",
      "VIDEO": "Video",
      "DOCUMENT": "Document",
      "CALL_TO_ACTION": "Call-to-action",
      "COPY_CODE": "Code kopiëren"
    },
    "PREVIEW": {
      "TITLE": "Voorbeeld van template",
      "DESCRIPTION": "Bekijk een voorbeeld van hoe deze template wordt weergegeven in WhatsApp.",
      "OPEN": "Voorbeeld van {name}",
      "CLOSE": "Voorbeeld sluiten",
      "DETAILS": "Templatedetails",
      "STATUS": "Status",
      "TYPE": "Inhoudstype",
      "CATEGORY": "Categorie",
      "LANGUAGE": "Taal",
      "INBOXES": "Inboxen"
    }
  }
}
